import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import Responses from "./Responses.jsx";
import { useTranslation } from "../../../../language";

export default function QuestionnaireWelcome() {
  const { t } = useTranslation();

  return (
    <PageProtectedLayout
      headline={t("page_hl_questionnaire")}
      specify={t("page_sp_your_responses")}
    >
      <Responses />
    </PageProtectedLayout>
  );
}
